module.exports = __webpack_public_path__ + "static/media/banner@3x.7ac1ab44.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/about-us/images/banner@3x.jpg
// module id = 1108
// module chunks = 2